import React, { useEffect, useState } from 'react'
import { useLoaderData } from 'react-router-dom';
import { LoadingData } from '../../components/Loading';
import Pagination from '../../components/Pagination';
import { formatDate } from '../../utils/methods';

export default function Proceedings() {
  const [data, setData] = useState([]);
  const [proceedings, setProceedings] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);

  const serverData = useLoaderData()

  useEffect(() => {
    setData(serverData)
    return () => { }
  }, [serverData])

  useEffect(() => {
    if (data && data.docs) {
      setPage(data?.page)
      setProceedings(data?.docs);
    }
  }, [data])
  
  return (
    <div className="w-full">
      <h4 className="text-xl font-fira font-semibold capitalize">Proceedings</h4>
      <div className="mt-6 bg-white pt-3 rounded-lg">
        <div className="">
          <div className="px-4 mb-4 flex justify-between items-center">
            <h4 className="text-sm font-semibold font-fira text-gray-800">All Proceedings</h4>
            <h4 className="text-xs font-semibold text-gray-800">Current Page {page}</h4>
          </div>
          <div className="w-full overflow-x-scroll">
            <table className="min-w-max w-full table-auto">
              <thead className="text-xs font-fira bg-gray-200 rounded-t-lg">
                <tr>
                  <th className="py-3 px-8 text-left">Case Id</th>
                  <th className="py-3 px-8 text-left">Mediator</th>
                  <th className="py-3 px-8 text-left">Date</th>
                  <th className="py-3 px-8 text-left">Time</th>
                  <th className="py-3 px-8 text-left">Link</th>
                </tr>
              </thead>
              <tbody>
                {Array.from(proceedings).map((pr) => (<tr key={pr._id} className="border-b-2 font-semibold text-xs border-gray-200 hover:bg-gray-100">
                  <td className='py-3 px-8 text-left whitespace-nowrap'>
                    <span>{pr.residingcase.uid}</span>
                  </td>
                  <td className='py-3 px-8 text-left whitespace-nowrap'>
                    <div className="flex gap-2 items-center justify-center">
                      <img src={pr.mediator.avatar} alt="" className="w-8 h-8 rounded-full border-2 border-gray-200" />
                      <div>
                        <h4 className="text-xs font-semibold">{pr.mediator.name}</h4>
                        <a className="text-xs text-blue-900" href={`mailto:${pr.mediator.email}`}>{pr.mediator.email}</a>
                      </div>
                    </div>
                  </td>
                  <td className='py-3 px-8 text-left whitespace-nowrap'>
                    <span>{formatDate(pr.date, 'DD MMM, YYYY')}</span>
                  </td>

                  <td className='py-3 px-8 text-left whitespace-nowrap'>
                    <span>{pr.time}</span>
                  </td>

                  <td className='py-3 px-8 text-left whitespace-nowrap'>
                    <a href={pr.link} className="text-indigo-900">link</a>
                  </td>
                </tr>))}
              </tbody>
            </table>
          </div>
          {(proceedings.length < 1 && !loading) && <div className="no-case flex py-8 px-6 flex-col justify-center gap-6">
            <div className="text-center">
              <h4 className="font-semibold font-fira text-lg">No Proceeding Record</h4>
            </div>
          </div>}
          {loading && <div className="mt-10">
            <LoadingData message="Loading Proceedings..." />
          </div>}
        </div>
      </div>
      {<Pagination currentData={data} setData={setData} setLoading={setLoading} />}
    </div>
  )
}
